import styled from 'styled-components';

export const AccordionWrapper = styled.div`
  background: ${props => props.theme.colors.background.secondary};
  padding: 16px 0;
`;
